import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import { LocaleService } from '@shared/services/locale.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment as env } from '@environments/environment';
import { Title } from '@angular/platform-browser';
import { User } from '@core/models';

@Component({
	selector: 'app-payment-provider',
	templateUrl: './payment-provider.component.html',
	styleUrls: ['./payment-provider.component.scss'],
})
export class PaymentProviderComponent implements OnInit {
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		public locale: LocaleService,
		private auth: AuthService,
		private readonly deviceDetectorService: DeviceDetectorService,
		private title: Title
	) {}

	embedded: boolean = false;
	adID: string;
	user: User = this.auth.user();
	loading: boolean = false;
	paymentMode: string;
	package: string;
	voucherType: string;
	onBack() {
		window.history.back();
	}

	onOpenWhatsapp() {
		const targetDisplay = this.deviceDetectorService.isMobile() ? '_self' : '_blank';
		window.open(env.WHATSAPP.callForHelpUrl, targetDisplay);
	}

	onSubmit() {
		this.router.navigate(['./code'], {
			relativeTo: this.route,
			queryParams: {
				adID: this.adID,
				mode: this.paymentMode,
				package: this.package,
				provider: this.voucherType,
			},
		});
	}

	ngOnInit(): void {
		this.route.queryParams.subscribe((queries: Params) => {
			if (queries['adID']) {
				this.adID = queries['adID'];
			}

			if (queries['mode']) {
				this.paymentMode = queries['mode'];
			}

			if (queries['package']) {
				this.package = queries['package'];
			}

			if (queries['embedded']) {
				this.embedded = queries['embedded'];
			}
		});

		this.title.setTitle(this.locale.translations['payment']['n209'] + ' | ' + this.locale.translations['header']['n0']);
	}
}
